import { handleGetRequest } from "./http.service";
import { PaginationDataRes } from "types/http.type";
import { FunnelStats, ProductEvent, ProductEventFilters, TopPathStat } from "types/productEvent.type";
import { PaginationParams } from "types/general.interface";

const buildQuery = (params: Record<string, string | number | undefined>) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== "") query.set(key, String(value));
  });
  return query.toString();
};

export const getProductEvents = async (
  pagination: PaginationParams,
  filters: ProductEventFilters
) => {
  const qs = buildQuery({ ...pagination, ...filters });
  return await handleGetRequest<PaginationDataRes<ProductEvent[]>>(
    `/admins/product-events?${qs}`
  );
};

export const getFunnelStats = async (
  funnel: string,
  range: { from?: string; to?: string }
) => {
  const qs = buildQuery({ funnel, ...range });
  return await handleGetRequest<FunnelStats>(
    `/admins/product-events/funnel-stats?${qs}`
  );
};

export const getTopPaths = async (range: { from?: string; to?: string }) => {
  const qs = buildQuery({ ...range });
  return await handleGetRequest<TopPathStat[]>(
    `/admins/product-events/top-paths?${qs}`
  );
};
